import { log } from '../log/OpenPixLogger.tsx';
import { isArray } from '../type.tsx';

export const dataLayerHelper = (dataLayer: unknown[]) => {
  const oldPush = dataLayer.push;

  const unprocessed_: unknown[] = [];
  let processed_ = false;
  const commandProcessors_ = {};

  const registerProcessor = (
    name: string,
    processor: (...args: any) => void,
  ) => {
    if (!(name in commandProcessors_)) {
      commandProcessors_[name] = [];
    }

    commandProcessors_[name].push(processor);
  };

  const processCommand = (name, args) => {
    if (commandProcessors_[name]) {
      // Cache length so as not to run processors registered
      // by other processors after the call.
      // This could happen if somebody calls the registerProcessor() method
      // within a processor call.
      const length = commandProcessors_[name].length;

      for (let i = 0; i < length; i++) {
        const callback = commandProcessors_[name][i];

        callback.apply(callback, args);
      }
    }
  };

  const processStates = (states: unknown[]) => {
    if (!processed_) {
      return;
    }

    // eslint-disable-next-line
    unprocessed_.push.apply(unprocessed_, states);

    while (unprocessed_.length > 0) {
      const update = unprocessed_.shift();

      log('update: ', update);

      if (isArray(update)) {
        processCommand(update[0], update.slice(1));
      }
    }
  };

  // TODO - process "old events"
  dataLayer.push = function () {
    // eslint-disable-next-line
    const states = [].slice.call(arguments, 0);

    const result = oldPush.apply(dataLayer, states);

    processStates(states);

    return result;
  };

  const process = () => {
    if (processed_) {
      log('Process already run.');

      return;
    }

    processed_ = true;
    const startingLength = dataLayer.length;

    for (let i = 0; i < startingLength; i++) {
      // Run the commands one at a time to maintain the correct
      // length of the queue on each command.
      processStates([dataLayer[i]]);
    }
  };

  return {
    process,
    registerProcessor,
  };
};
